import sprinkle from './assets/pexels-burst-374020.jpg'

/*
export default {
  heroContainer: {
    bg: `white`,
    pt: [6, 7],
    pb: [5, 6],
    px: [4, 0]
  },
  contentTwoContainer: {
    bg: `omegaDarker`,
    borderRadius: `xl`,
    py: [4, 5],
    px: [4, 0]
  }
}*/
export default {
  heroContainer: {
    position: `relative`,
    pt: [6, 7],
    '::before, ::after': {
      position: `absolute`,
      content: `" "`,
      width: `full`,
      height: `2/5`,
      top: 0,
      right: 0
    },
    '::before': {
      zIndex: -3,
      bg: `white`,
      background: t => `linear-gradient(
        145deg,
        ${t.colors.bgCardinalLight} 0%,
        ${t.colors.bgCardinalDark} 100%
      )`
    },
    '::after': {
      zIndex: -2,
      background: `url(${sprinkle}) repeat right top`,
      opacity: 0.35
    }
  },
  servicesContainer: {
    px: [3, 4]
  }
}